import React, { FC, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { IChannel, ISelection } from "../helper";
import { IVideo } from "../../../admin/videos/hooks/useFetchVideos";
import { MediaIndividualView } from "./mediaIndividualView";
import config from "../../../../config";

interface Props {
  group: any;
  files: Array<IVideo>;
  channel: IChannel;
  selections: Array<ISelection>;
  setSelections: (data: Array<any>) => void;
}

export const MediaIndividualDetails: FC<Props> = (props) => {
  const { channel, files } = props;
  const { projectId } = useParams();

  const iframeUrl = useMemo(
    () => `${config.EMBED_HOST}/assets/js/e2s.js?source=embed&p=${projectId}`,
    [projectId]
  );

  useEffect(() => {
    /* @ts-ignore */
    window.tdcEmbedLoaded = false;
    /* @ts-ignore */
    window.tdcEmbedSingleLoaded = false;
    const script = document.createElement("script");
    script.src = iframeUrl;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [iframeUrl, channel]);

  return (
    <div className="mt-8 flex flex-col gap-12">
      {files.map((file) => (
        <MediaIndividualView
          {...props}
          iframeUrl={iframeUrl}
          file={file}
          key={`video-${file.id}`}
        />
      ))}
    </div>
  );
};
